import { OrganizationsService } from 'app/API';
import { cancelOnSignal } from 'app/API/core/CancelablePromise';
import type { QueryFunctionContext } from '@tanstack/react-query';
import type { organizationsKeys } from 'app/queries/organizations/organizationsKeys';
import type { TCall } from 'app/queries/types/TCall';
import { buildOrgMemberReportsRequest } from './buildOrgMemberReportsRequest';

type TParams = QueryFunctionContext<ReturnType<typeof organizationsKeys.memberReportsList>>;

export const createFetchOrgMemberReportsQueryFn =
  (call: TCall) =>
  ({ queryKey: [{ organizationId, params }], signal }: TParams) =>
    call(() =>
      cancelOnSignal(
        OrganizationsService.getOrgMemberReports(buildOrgMemberReportsRequest(organizationId, params)),
        signal,
      ),
    );
